import { IUser, IUserMap } from "@/common/services/types";

export const filterUsersList = (prevUsers: IUserMap, newUsers: IUser[]) => {
  const users = { ...prevUsers };

  newUsers.forEach((user: IUser) => {
    users[user.username] = user;
  });

  return users;
};
